import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import routes from './routes';
import getMeGuard from '@/router/guards/getMeGuard.js';
import { App } from '@capacitor/app';

Vue.use(Router);

const router = new Router({
    //mode: "history",
    base: process.env.BASE_URL,
    routes,
    /**
     * @override
     */
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    getMeGuard(to, from, next);
});

router.afterEach(() => {
    store.dispatch('hideLoading');
});

App.addListener('appUrlOpen', function (event) {
    // TODO: revisar si pasa por aquí
    const url = new URL(event.url);

    const utmSource = url.searchParams.get('utm_source');
    if (utmSource === 'cobasplus') {
        localStorage.setItem('isFromCobasPlusLanding', 'true');
    }

    // TODO: revisar qué pasa con esto
    let slug = null;

    if (event.url.includes('cobasapp://')) {
        slug = event.url.split('cobasapp://').pop().split('#').pop();
    }

    if (event.url.includes('/private/app')) {
        slug = event.url.split('/private/app').pop().split('#').pop();
    }

    if (slug) {
        router.push({
            path: slug
        });

        // Para que no quede el foco en el botón
        document.activeElement?.blur();
    }
});

export default router;
